import {
  EPredictiveOrderStatus,
  ETypeInstrument,
  ETypePredictive,
} from "../../hooks/usePredictives";
import { EValidityType } from "../predictiveValidity";
import { IColor } from "../selectColors";

const colorTextPredictiveOrderStatus = (status: EPredictiveOrderStatus) => {
  const colorText: Record<
    EPredictiveOrderStatus,
    { text: string; color: IColor }
  > = {
    NONE: {
      text: "---",
      color: IColor.waiting,
    },
    ACTIVE: {
      text: "global.predictive_function.status.active",
      color: IColor.blue,
    },
    PENDING: {
      text: "global.predictive_function.status.pending",
      color: IColor.yellow,
    },
    PENDING_CANCELLATION: {
      text: "global.predictive_function.status.pending_cancellation",
      color: IColor.yellow,
    },
    PENDING_MODIFICATION: {
      text: "global.predictive_function.status.pending_modification",
      color: IColor.yellow,
    },
    RESERVED: {
      text: "global.predictive_function.status.reserved",
      color: IColor.violet,
    },
    ACCEPTED: {
      text: "global.predictive_function.status.accepted",
      color: IColor.green,
    },
    WAITING_MARKET: {
      text: "global.predictive_function.status.waiting_market",
      color: IColor.waiting,
    },
    WAITING_FOR_SHOT: {
      text: "global.predictive_function.status.waiting_for_shot",
      color: IColor.waiting,
    },
    FIRED: {
      text: "global.predictive_function.status.fired",
      color: IColor.green,
    },
    EXECUTED: {
      text: "global.predictive_function.status.executed",
      color: IColor.green,
    },
    REJECTED: {
      text: "global.predictive_function.status.rejected",
      color: IColor.red,
    },
    SUSPENDED: {
      text: "global.predictive_function.status.suspended",
      color: IColor.loading,
    },
    PARTIALLY_EXECUTED: {
      text: "global.predictive_function.status.partially_executed",
      color: IColor.orange,
    },
    CANCELLED: {
      text: "global.predictive_function.status.cancelled",
      color: IColor.red,
    },
    MODIFIED: {
      text: "global.predictive_function.status.modified",
      color: IColor.purple,
    },
    EXPIRED: {
      text: "global.predictive_function.status.expired",
      color: IColor.loading,
    },
    PREVIOUS: {
      text: "global.predictive_function.status.previous",
      color: IColor.loading,
    },
  };
  return (
    colorText[status] || {
      text: "---",
      color: IColor.waiting,
    }
  );
};

const orderTypeText = (type: ETypePredictive) => {
  if (type === ETypePredictive.MARKET_PROTECTION) {
    return "global.predictive_function.order_type.market_protection";
  } else if (type === ETypePredictive.LIMIT) {
    return "global.predictive_function.order_type.limit";
  } else {
    return "---";
  }
};

const validityText = (type: EValidityType) => {
  if (type === EValidityType.TODAY) {
    return "global.predictive_function.validity.today";
  } else if (type === EValidityType.UNTIL_CANCEL) {
    return "global.predictive_function.validity.until_cancel";
  } else if (type === EValidityType.UNTIL_DATE) {
    return "global.predictive_function.validity.until_date";
  } else {
    return "---";
  }
};

const isBloquedEditOrDelete = (status: EPredictiveOrderStatus) => {
  if (
    status === EPredictiveOrderStatus.PARTIALLY_EXECUTED ||
    status === EPredictiveOrderStatus.MODIFIED ||
    status === EPredictiveOrderStatus.PREVIOUS ||
    status === EPredictiveOrderStatus.WAITING_MARKET ||
    status === EPredictiveOrderStatus.WAITING_FOR_SHOT
  ) {
    return false;
  }
  return true;
};

const colorTextPredictiveOrderSide = (status: ETypeInstrument) => {
  const colorText: Record<ETypeInstrument, { text: string; color: IColor }> = {
    SELL: {
      text: "global.predictive_function.side.sell",
      color: IColor.orange,
    },
    BUY: {
      text: "global.predictive_function.side.buy",
      color: IColor.babyBlue,
    },
  };
  return colorText[status] || colorText["BUY"];
};

const colorTextPredictiveOrderPercentage = (percentage: number) => {
  const value = Math.abs(percentage);
  const percentageTranslation = value.toLocaleString("pt-BR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  if (percentage > 0) {
    return {
      text: "global.predictive_function.percentage.high",
      percentage: percentageTranslation,
      color: IColor.green,
    };
  } else if (percentage < 0) {
    return {
      text: "global.predictive_function.percentage.low",
      percentage: percentageTranslation,
      color: IColor.red,
    };
  } else {
    return {
      text: "global.predictive_function.percentage.keep",
      color: IColor.copom,
    };
  }
};

export {
  colorTextPredictiveOrderStatus,
  orderTypeText,
  validityText,
  isBloquedEditOrDelete,
  colorTextPredictiveOrderSide,
  colorTextPredictiveOrderPercentage,
};
